import { render, staticRenderFns } from "./mision-vision.vue?vue&type=template&id=025766a3&scoped=true"
import script from "./mision-vision.vue?vue&type=script&lang=js"
export * from "./mision-vision.vue?vue&type=script&lang=js"
import style0 from "./mision-vision.vue?vue&type=style&index=0&id=025766a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025766a3",
  null
  
)

export default component.exports